import "./src/components/fonts/Berkeley/BerkeleyMono.css"
import "./src/components/fonts/Inter/inter.css"
import "./src/components/fonts/Satoshi/css/satoshi.css"
require("prismjs/themes/prism.css")
